import React from 'react';
import SuggestionPanel from './SuggestionPanel';
import { useNotifications } from 'hooks/useNotifications';

interface SidePanelProps {
  /**
   * Type of panel - always 'suggestions' now
   * Kept for backward compatibility but can be removed if not needed
   */
  panelType?: 'suggestions';
}

/**
 * SidePanel component that displays suggestions only
 */
const SidePanel: React.FC<SidePanelProps> = ({}) => {
  // Use our custom hook to handle the notification data and polling
  // Pass 'suggestions' to only fetch suggestions data
  const { suggestions } = useNotifications('suggestions');

  return (
    <div className='side-panel suggestions-only'>
      <SuggestionPanel suggestions={suggestions} />
    </div>
  );
};

export default SidePanel;
